const actionTypeIdentifier = 'CD2C601C-671B-4A58-8555-36F27B1F4F2A'; // to generate open ssms run select newid()

//location form actions
export const setTerminateDate = `SET-WIRELESS-TERMINATE-SUBSCRIPTION-TERMINATE-DATE-${actionTypeIdentifier}`;
export const setSubscriptionDetails = `SET-WIRELESS-TERMINATE-SUBSCRIPTION-SUBSCRIPTION-DETAILS-${actionTypeIdentifier}`;
export const setFormSubmitted = `SET-WIRELESS-TERMINATE-SUBSCRIPTION-FORM-SUBMITTED-${actionTypeIdentifier}`;
export const setRequestSelectedData = `SET-REQUEST-SELECTED-DATA-${actionTypeIdentifier}`;
export const setResetLoading = `SET-WIRELESS-PORTOUT-SUBSCRIPTION-RESET-LOADING-${actionTypeIdentifier}`;

export const wirelessTerminateModel = {
    circuitCode: ''
    , circuitId: 0
    , terminateDate: ''
    , businessJustification: ''
    , additionalInformation: ''
    , vendor: ''
    , plan: ''
}
